// السطر النصي — الكتابة كما في رسالة واتساب.
// أرخص من الصوت وأذكى منه عملياً: صامت، بلا ضجيج، بلا إنترنت، وبلا تكلفة على كل حركة.
// ولا يُحفظ شيء قبل المراجعة: حركة خاطئة تُحفظ بصمت تسمّم البيانات وتقتل الثقة.

import { fmt, esc } from '../util.js';
import { addEntry, addDest, destName, typeName, activeDests, CURRENCIES } from '../store.js';
import { parseLine, suggestionsFor } from '../parse.js';
import { backBar, emptyState } from '../ui.js';

export function freshDraft(){
  return { text: '', rows: null };
}

const SAMPLES = [
  'مدرسة أحمد ٥ وعلي ٤ وآية ٣',
  'تموين ٦٠ ومحروقات مية وخمسين',
  'قرطاسية آية ٥',
  'آية ٥ قرطاسية',
  'دخل ألفين شيكل راتب'
];

export function render(app){
  const d = app.textDraft;
  const rows = d.rows;
  const ready = rows && rows.length && rows.every(r => r.destId && r.amount > 0);

  const parsed = rows ? rows.map((r, i) => {
    const dTag = r.destId
      ? `<span class="tag ${r.kind === 'in' ? 'i' : 'd'}">${esc(destName(r.destId))}${r.guessed ? ' ·تلقائي' : ''}</span>`
      : '<span class="tag non">وجهة؟</span>';
    const tTag = r.kind === 'in'
      ? '<span class="tag i">دخل</span>'
      : (r.typeId ? `<span class="tag t">${esc(typeName(r.typeId) || '')}</span>`
                  : '<span class="tag non">بلا نوع</span>');
    const sym = (CURRENCIES[r.currency] || { sym: '' }).sym;
    const fixes = r.destId ? '' : `<div class="strip noscroll" style="margin-top:8px;gap:5px">${
      suggestionsFor(r).map(name =>
        `<button type="button" class="chip" data-fix="${i}|${esc(name)}">${esc(name)}</button>`).join('')
    }<button type="button" class="chip ghost" data-fix="${i}|__new__">إنشاء «${esc(r.raw || 'جديدة')}»</button></div>`;

    return `<div class="row" style="flex-wrap:wrap;${r.destId ? '' : 'border-color:var(--up)'}">
        <span class="tags">${dTag}${tTag}</span>
        <span class="val">${r.kind === 'in' ? '+' : ''}${fmt(r.amount)}<small>${sym}</small></span>
        ${r.issue ? `<div style="flex-basis:100%;font-size:11.5px;color:var(--up);font-weight:600">⚠ ${esc(r.issue)}</div>` : ''}
        ${fixes ? `<div style="flex-basis:100%">${fixes}</div>` : ''}
      </div>`;
  }).join('') : '';

  return backBar('سطر نصي', 'اكتب بأي ترتيب — كل كلمة تعرف بُعدها بنفسها')
    + `<div class="scroll">
        <textarea class="tin" id="tin" placeholder="مثال: مدرسة أحمد ٥ وعلي ٤ وآية ٣">${esc(d.text)}</textarea>
        <div class="strip noscroll" style="margin-top:10px;gap:5px">
          ${SAMPLES.map(s => `<button type="button" class="chip ghost" data-sample="${esc(s)}">${esc(s)}</button>`).join('')}
        </div>
        ${rows ? (rows.length ? `<div style="margin-top:14px">${parsed}</div>`
                              : emptyState('لم أجد أي مبلغ', 'اكتب اسماً ورقماً، مثل «تموين ٦٠».')) : ''}
      </div>`
    + `<div class="linkrow"><button type="button" data-act="parse">تحليل السطر</button></div>`
    + `<button type="button" class="cta" data-act="savetext" ${ready ? '' : 'disabled'}>
        ${rows && rows.length ? `حفظ ${rows.length} حركة` : 'اكتب سطراً ثم حلّله'}</button>`;
}

export function mount(app, root){
  const ta = root.querySelector('#tin');
  if (ta) ta.addEventListener('input', () => { app.textDraft.text = ta.value; });
}

export function onClick(app, btn){
  const d = app.textDraft;

  if (btn.dataset.sample){
    d.text = btn.dataset.sample;
    d.rows = parseLine(d.text).rows;
    return app.render();
  }
  if (btn.dataset.act === 'parse'){
    const ta = document.querySelector('#tin');
    if (ta) d.text = ta.value;
    d.rows = parseLine(d.text).rows;
    return app.render();
  }
  if (btn.dataset.fix){
    const [idx, name] = btn.dataset.fix.split('|');
    const row = d.rows[+idx];
    if (!row) return;
    if (name === '__new__'){
      const created = addDest(row.raw || 'جهة جديدة');
      if (created) row.destId = created.id;
    } else {
      const hit = activeDests().find(x => x.name === name);
      if (hit) row.destId = hit.id;
    }
    row.issue = null;
    row.guessed = false;
    return app.render();
  }
  if (btn.dataset.act === 'savetext'){
    if (!d.rows || !d.rows.length) return;
    const made = [];
    d.rows.forEach((r, i) => {
      if (!r.destId || !(r.amount > 0)) return;
      const e = addEntry({
        amount: r.amount, destId: r.destId, typeId: r.typeId,
        currency: r.currency, kind: r.kind,
        occurredAt: new Date(Date.now() + i)
      });
      made.push(e.id);
    });
    if (!made.length) return;
    app.textDraft = freshDraft();
    app.closeSub();
    app.toast(`حُفظت ${made.length} حركة من سطر واحد`, 'تراجع', () => app.undoEntries(made));
    app.queueSync();
    return;
  }
  return false;
}
